import type { ImportBatch } from "../types";

export interface ParsedFile {
  fileName: string;
  fileHash: string;
  headers: string[];
  rows: Record<string, unknown>[];
  ignoredRows?: number;
  warnings?: string[];
}

export interface ColumnMapping {
  sku: string;
  color: string;
  quantity: string;
  order?: string;
  title?: string;
}

export interface ImportAdapter {
  readonly source: ImportBatch["source"];
  readonly automaticMapping: boolean;
  parse(file: File): Promise<ParsedFile>;
  suggestMapping(headers: string[]): ColumnMapping;
}

export const normalizeHeader = (value: unknown) => String(value ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-zA-Z0-9]/g, "")
  .toUpperCase();
